<div class="ngx-modal-header">
    <h4 class="modal-title pull-left">{{modalData ? modalData.title : ''}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div *ngIf="modalData && modalData.type === 'delete'">
        <div *ngIf="modalData.userInfo && modalData.userInfo.reporteesCount === 0">
            <app-delete-entity entity="user" [userInfo]="modalData.userInfo"
                (cancelCallback)="cancelCallback()"
                (deleteCallback)="deleteCallback()">
            </app-delete-entity>
        </div>
        <div *ngIf="modalData.userInfo && modalData.userInfo.reporteesCount > 0">
            <p>
                There are users reporting to this user. Please re-assign or delete these users before attempting to
                delete this user.
            </p>
            <div class="text-right">
                <div class="clearfix">
                    <button type="button" class="btn btn-primary" (click)="closeModal(null)">Ok</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="modalData && modalData.type === 'convertUserToEmployee'">
        <app-convert-user-to-employee
            [userId]="modalData.userId"
            (saveCallback)="saveCallback($event)"
            (cancelCallback)="cancelCallback()">
        </app-convert-user-to-employee>
    </div>

    <div *ngIf="modalData && modalData.type === 'activities'">
        <app-entity-activities
            [userId]="modalData.userInfo ? modalData.userInfo.userId : null"
            [userName]="modalData.userInfo ? modalData.userInfo.name : null"
            [activityMap]="modalData.activityMap"
            [context]="modalData.context">
        </app-entity-activities>
    </div>
</div>
